import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {T as Typography} from "./index-6e985b71.js";
import {L as ListContext_1} from "./ListContext-0f0f18c4.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
import _jsxRuntime from "react/jsx-runtime";
var listItemTextClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getListItemTextUtilityClass = getListItemTextUtilityClass;
  function getListItemTextUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiListItemText", slot);
  }
  const listItemTextClasses = (0, core.generateUtilityClasses)("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
  var _default = listItemTextClasses;
  exports.default = _default;
});
var ListItemText_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _Typography = interopRequireDefault(Typography);
  var _ListContext = interopRequireDefault(ListContext_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  var _listItemTextClasses = _interopRequireWildcard(listItemTextClasses_1);
  const _excluded = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      inset,
      primary,
      secondary,
      dense
    } = ownerState;
    const slots = {
      root: ["root", inset && "inset", dense && "dense", primary && secondary && "multiline"],
      primary: ["primary"],
      secondary: ["secondary"]
    };
    return (0, core.unstable_composeClasses)(slots, _listItemTextClasses.getListItemTextUtilityClass, classes);
  };
  const ListItemTextRoot = (0, _styled.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [{
        [`& .${_listItemTextClasses.default.primary}`]: styles.primary
      }, {
        [`& .${_listItemTextClasses.default.secondary}`]: styles.secondary
      }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
    }
  })(({
    ownerState
  }) => (0, _extends2.default)({
    flex: "1 1 auto",
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  }, ownerState.primary && ownerState.secondary && {
    marginTop: 6,
    marginBottom: 6
  }, ownerState.inset && {
    paddingLeft: 56
  }));
  const ListItemText2 = /* @__PURE__ */ React$1.forwardRef(function ListItemText3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiListItemText"
    });
    const {
      children,
      className,
      disableTypography = false,
      inset = false,
      primary: primaryProp,
      primaryTypographyProps,
      secondary: secondaryProp,
      secondaryTypographyProps
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const {
      dense
    } = React$1.useContext(_ListContext.default);
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, _extends2.default)({}, props, {
      disableTypography,
      inset,
      primary: !!primary,
      secondary: !!secondary,
      dense
    });
    const classes = useUtilityClasses(ownerState);
    if (primary != null && primary.type !== _Typography.default && !disableTypography) {
      primary = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Typography.default, (0, _extends2.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: "span",
        display: "block"
      }, primaryTypographyProps, {
        children: primary
      }));
    }
    if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
      secondary = /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Typography.default, (0, _extends2.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
      }, secondaryTypographyProps, {
        children: secondary
      }));
    }
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(ListItemTextRoot, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      ownerState,
      ref
    }, other, {
      children: [primary, secondary]
    }));
  });
  var _default = ListItemText2;
  exports.default = _default;
});
var ListItemText = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    listItemTextClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _ListItemText.default;
    }
  });
  Object.defineProperty(exports, "listItemTextClasses", {
    enumerable: true,
    get: function() {
      return _listItemTextClasses.default;
    }
  });
  var _ListItemText = interopRequireDefault(ListItemText_1);
  var _listItemTextClasses = _interopRequireWildcard(listItemTextClasses_1);
  Object.keys(_listItemTextClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _listItemTextClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _listItemTextClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(ListItemText);
export {ListItemText as L, __pika_web_default_export_for_treeshaking__ as _};
